import * as React from "react";
import Icon from 'components/Icon';
import ZBox from 'components/ZBox';

export default function SliderArrows({refFunction, ...props}) {
	if (!refFunction) {
		return null;
	}
	return (
		<ZBox className="slider__arrows">
			<button ref={(ref) => (refFunction ? refFunction.current[0] = ref : null)} className={['arrow', 'swiper-button-prev-custom', 'swiper-button-prev'].join(' ')}>
				<Icon symbol="chevron-left" foreground={'#000000'} width={9} height={18} />
			</button>
			<button ref={(ref) => (refFunction ? refFunction.current[1] = ref : null)} className={['arrow', 'swiper-button-next-custom', 'swiper-button-next'].join(' ')}>
				<Icon symbol="chevron-right" foreground={'#000000'} width={9} height={18} />
			</button>
		</ZBox>
	);
}